import { SxProps } from "@mui/material"

export const LandingLayoutProps: SxProps = {
  minWidth: "100%",
  minHeight: "100%",
  overflow: "auto",
  background:
    "linear-gradient(114deg, rgba(33,94,205,1) -10%, rgba(22,170,220,1) 45%, rgba(53,199,73,1) 100%)",
}
